require('./slider');

Pegasus.DesignToolbarView = Em.View.extend({
  rowPaddingTopSlider: Pegasus.SliderView.extend({
    propertyBinding: 'controller.dataVrStructurePaddingTop',
    showInput: true,
    options: function(){
      return {
        start:[this.get('property')],
        range: {
          'min': 0,
          'max': 150
        }
      };
    }
  }),

  rowPaddingBottomSlider: Pegasus.SliderView.extend({
    propertyBinding: 'controller.dataVrStructurePaddingBottom',
    showInput: true,
    options: function(){
      return {
        start:[this.get('property')],
        range: {
          'min': 0,
          'max': 150
        }
      };
    }
  }),

  columnPaddingLeftSlider: Pegasus.SliderView.extend({
    propertyBinding: 'controller.column.leftSpacer.dataVrStructureHorizontalSpaceLeft',
    showInput: true,
    options: function(){
      return {
        start:[this.get('property')],
        range: {
          'min': 0,
          'max': 150
        }
      };
    }
  }),

  columnPaddingRightSlider: Pegasus.SliderView.extend({
    propertyBinding: 'controller.column.rightSpacer.dataVrStructureHorizontalSpaceRight',
    showInput: true,
    options: function(){
      return {
        start:[this.get('property')],
        range: {
          'min': 0,
          'max': 150
        }
      };
    }
  })
});
